module.exports = __webpack_public_path__ + "img/support-of-palma-cultura-festivals.b126bdc1.jpg";